import type { FilterFormLabels, FilterFormValues } from './types';

export const defaultFormValues: FilterFormValues = {
    destination: [],
    theme: [],
    startDate: undefined,
    endDate: undefined,
    months: [],
    flexibility: 0,
    // adults: '0',
    // children: '0',
    // childrenAges: [],
    nbPax: '0',
    // secondary
    levels: [],
    types: [],
    durationMin: null,
    durationMax: null,
    budgetMin: null,
    budgetMax: null,
    tags: [],
    resorts: [],
    bestReviewed: false,
    exclusiveSport: false,
};

export const defaultFormLabels: FilterFormLabels = {
    destination: [],
    theme: [],
    startDate: undefined,
    endDate: undefined,
    months: [],
    nbPax: '',
    // secondary
    levels: '',
    types: '',
    duration: '',
    budget: '',
    tags: '',
};
